import { cn } from '../../../lib/utils'
import { Card } from '../../ui/card'
import React from 'react'

interface WorkoutStatCardProps {
  children: React.ReactNode
  className?: string
}

export const WorkoutStatCard = ({ children, className }: WorkoutStatCardProps): React.ReactElement => {
  return (
    <Card
      className={cn(
        'relative flex flex-col items-center justify-center rounded-md bg-secondary-gray p-[20px] !border-none',
        className,
      )}
    >
      {children}
    </Card>
  )
}
